import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import UserList from "../../components/UserManagement/UserList";
const UserListPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <UserList/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};
export default UserListPage;